import { Link, useNavigate, useParams } from "react-router-dom";
import patient from "../../../assets/img/patient.jpg";
import { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import Textarea from "../../../components/text-area";
import { prompts } from "../../../util/dummyJson";
import { ADMINPROMPTS } from "../../../action/apiPath";
import { CallWithAuth } from "../../../action/apiActions";
import { showToast } from "../../../util/toastHelper";
import arrorRight from "../../../assets/img/arrow-right.svg";
import { ADMINPROMPTSADD, ADMINPROMPTSEDIT } from "../../../util/path";
import Loading from "react-fullscreen-loading";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminPromptsList = () => {
  const navigate = useNavigate();

  const [apiEndpointNameList, setApiEndpointNameList] = useState([
    { value: "collateral", level: "Collateral" },
    { value: "background_info", level: "Background Information" },
    { value: "mse", level: "Mental Status Examination (MSE)" },
    { value: "standardised_assessment", level: "Standardised Assessment" },
    { value: "clinical_interviews", level: "Clinical Interviews" },
    { value: "formulation", level: "Formulation" },
    { value: "diagnose", level: "Diagnosis" },
    { value: "recommendation", level: "Recommendation" },
    { value: "recommendations", level: "Recommendations" },
    { value: "assessment_data", level: "Assessment Data" },
  ]);

  const [isLoading, setIsLoading] = useState(true);
  const textareaRef = useRef(null);

  const [prmoptslist, setPrmoptsList] = useState([]);

  const [expandedRows, setExpandedRows] = useState([]);


  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height based on scrollHeight
    }
  };

  // Re-run on text change
  const [prompt, setPrompt] = useState({});

  useEffect(() => {
    adjustHeight(); // Adjust height on initial render
  }, [prompt]);
  useEffect(() => {
    getPromptData();
  }, []);

  const toggleExpand = (index) => {
    setExpandedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  const getPromptData = async () => {
    try {
      setIsLoading(true);
      const response = await CallWithAuth("GET", ADMINPROMPTS);
      if (response.res.status == 200) {
        setPrmoptsList(response?.res?.data?.data);
      } else {
        showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const validatePromptData = (data) => {
    const errors = {};

    if (!data.background_info || data.background_info.trim() === "") {
      errors.background_info = "Background information is required.";
    }

    if (!data.collateral || data.collateral.trim() === "") {
      errors.collateral = "Collateral is required.";
    }

    if (!data.mse || data.mse.trim() === "") {
      errors.mse = "MSE (Mental State Examination) is required.";
    }

    if (
      !data.standardised_assessment ||
      data.standardised_assessment.trim() === ""
    ) {
      errors.standardised_assessment = "Standardised assessment is required.";
    }

    if (!data.clinical_interviews || data.clinical_interviews.trim() === "") {
      errors.clinical_interviews = "Clinical interviews are required.";
    }

    if (!data.formulation || data.formulation.trim() === "") {
      errors.formulation = "Formulation is required.";
    }

    if (!data.diagnose || data.diagnose.trim() === "") {
      errors.diagnose = "Diagnosis is required.";
    }

    if (!data.recommendation || data.recommendation.trim() === "") {
      errors.recommendation = "Recommendation is required.";
    }

    return errors;
  };
  const savePrompts = async () => {
    try {
      const errors = validatePromptData(prompt); // Replace `promptData` with your state variable

      if (Object.keys(errors).length > 0) {
        const firstError = Object.values(errors)[0]; // Get the first error message
        // toast.error(firstError, { position: toast.POSITION.TOP_RIGHT });
        showToast("error", firstError);

        return;
      }
      const response = await CallWithAuth("PATCH", ADMINPROMPTS, prompt);
      if (response.res.status == 200) {
        showToast("success", "Prompt has been saved successfully.");
      } else {
        if (Array.isArray(response.res.data.message)) {
          showToast("error", response.res.data.message[0]);
        } else {
          showToast("error", response.res.data.message);
        }
      }
    } catch (error) {}
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPrompt((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDelete = async (promptsId) => {
    const result = await MySwal.fire({
      title: "Are you sure want to delete Prompt's?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      setIsLoading(true);
      try {
        const response = await CallWithAuth(
          "DELETE",
          `${ADMINPROMPTS}/${promptsId}`
        );
        if (
          response?.res?.data?.statusCode === 200 ||
          response?.res?.data?.statusCode === 201
        ) {
          showToast("success", "Prompts has been deleted successfully");
          getPromptData();
        } else {
          showToast("error", response?.res?.data?.message);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <Loading
            loading
            background="rgba(236, 240, 241, 0.7)"
            loaderColor="#3498db"
          />
        </>
      )}
      <div>
        <section className="site_hero patient_management_banner">
          <div className="site_container">
            <div className="site_row">
              <div className="txt_colm">
                <div className="txt_block">
                  <h1>Manage Prmopts File</h1>
                  <p>Manage each Prmopts efficiently</p>
                  <div className="btn_row">
                    <Link
                      to={`${ADMINPROMPTSADD}`}
                      className="solid_cta cta_primary cta_with_icon"
                    >
                      <span>Add Prmopts</span> <img src={arrorRight} alt="" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="img_colm">
                <div className="img_block">
                  <img src={patient} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="site_container">
          <div className="patient_form_block">
            <table className="table patient-row-details m-0">
              <thead>
                <tr>
                  <th width="15%">Api Name</th>
                  <th width="15%">Role</th>
                  <th width="15%">Practice Frameworker</th>
                  <th width="10%">Provisional Diagnostic Tool</th>
                  <th width="15%">Prompts Text</th>
                  <th width="10%" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* {selector?.data?.length
                          ? selector?.data?.map((patient, index) => ( */}
                {Array.isArray(prmoptslist) && prmoptslist.length > 0 && (
                  <>
                    {prmoptslist.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {apiEndpointNameList.find(
                            (endpoint) =>
                              endpoint.value === item.apiEndpointName
                          )?.level || item.apiEndpointName}
                        </td>
                        <td>{item?.selectRole}</td>
                        <td>{item?.practiceFramework?.name || "N/A"}</td>
                        <td>{item?.diagnosticTool?.name || "N/A"}</td>
                        {/* <td>{item?.promtText || "N/A"}</td> */}
                        <td>
                          {item?.promtText ? (
                            <>
                              {expandedRows.includes(index)
                                ? item.promtText
                                : item.promtText.slice(0, 100) + (item.promtText.length > 100 ? "..." : "")}
                              {item.promtText.length > 100 && (
                                <button
                                  onClick={() => toggleExpand(index)}
                                  style={{ marginLeft: 8, border: "none", background: "none", color: "blue", cursor: "pointer",fontWeight:"bold" }}
                                >
                                  {expandedRows.includes(index) ? "Show Less" : "Show More"}
                                </button>
                              )}
                            </>
                          ) : (
                            "N/A"
                          )}
                        </td>

                        <td>
                          <div className="d-flex gap-3 text-center patient-informartion-action" style={{ flexWrap: "wrap", justifyContent: "center" }}>
                            <button
                              // onClick={() => setModalShow(true)}
                              //   onClick={() =>
                              //     handleModal(item?.id)
                              //   }
                              onClick={() =>
                                navigate(`${ADMINPROMPTSEDIT}/${item?.id}`)
                              }
                              className="edit"
                            >
                              <i className="fa-solid fa-info"></i>
                            </button>
                            <button
                              onClick={() => handleDelete(item?.id)}
                              className="edit"
                            >
                              <i className="fa-solid fa-trash"></i>

                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
            {prmoptslist.length > 0 == 0 && (
              <h1 style={{ textAlign: "center" }}>No Prompts Found</h1>
            )}
          </div>
        </section>
      </div>
      <ToastContainer />
    </>
  );
};
export default AdminPromptsList;
